import { render, staticRenderFns } from "./LinkBuilderSettings.vue?vue&type=template&id=239a00d4&scoped=true"
import script from "./LinkBuilderSettings.vue?vue&type=script&lang=js"
export * from "./LinkBuilderSettings.vue?vue&type=script&lang=js"
import style0 from "./LinkBuilderSettings.vue?vue&type=style&index=0&id=239a00d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239a00d4",
  null
  
)

export default component.exports